import { useEffect, useState } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { transcriptorModel } from '@/entities/transcriptor';

import { DICTATION_COUNTDOWN_TICK_MS } from '../config';
import { getDictationRemainingSeconds } from '../lib';

const { selectDictationDeadlineAt, selectIsRecording, selectRecordingMode } =
  transcriptorModel.selectors;

// The seconds a dictation being recorded has left before scribe's deadline,
// or null for any other recording and for a dictation without a deadline.
export const useDictationCountdown = (): number | null => {
  const recordingMode = useAppSelector(selectRecordingMode);
  const deadlineAt = useAppSelector(selectDictationDeadlineAt);
  const isRecording = useAppSelector(selectIsRecording);
  const [now, setNow] = useState(() => Date.now());
  const counting = recordingMode === 'dictation' && isRecording && !!deadlineAt;

  useEffect(() => {
    if (!counting) {
      return undefined;
    }
    setNow(Date.now());
    const timer = window.setInterval(
      () => setNow(Date.now()),
      DICTATION_COUNTDOWN_TICK_MS,
    );
    return () => window.clearInterval(timer);
  }, [counting]);

  return counting ? getDictationRemainingSeconds({ deadlineAt, now }) : null;
};
